/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as o}from"../../../../webgl/Uniform.js";class r extends o{constructor(o,r,s){super(o,"float",2,(t,e,f)=>t.setUniform1f(o,r(e,f),s))}}export{r as FloatDrawUniform};
